/**
 * @generated SignedSource<<145a3d584450a2c65a7082afbaf306c2>>
 * @relayHash 78f7f047c2eeaba388f789341164eb05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8e088eb03f247f33e1a36638ceb73aeb312be09e8d8845193a7a0a0b4ff5c388

import type { ConcreteRequest } from 'relay-runtime';
export type ContentPropertiesQuery$variables = {
  contentId?: string | null | undefined;
  versionOverride?: number | null | undefined;
};
export type ContentPropertiesQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null | undefined;
      readonly operations: ReadonlyArray<{
        readonly operation: string | null | undefined;
        readonly targetType: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly properties: {
        readonly nodes: ReadonlyArray<{
          readonly id: string | null | undefined;
          readonly key: string | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly type: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type ContentPropertiesQuery = {
  response: ContentPropertiesQuery$data;
  variables: ContentPropertiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "versionOverride"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "version",
        "variableName": "versionOverride"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "type"
          },
          {
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
              }
            ],
            "concreteType": "PaginatedJsonContentPropertyList",
            "kind": "LinkedField",
            "name": "properties",
            "plural": false,
            "selections": [
              {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "key"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ],
            "storageKey": "properties(key:\"editor\")"
          },
          {
            "concreteType": "OperationCheckResult",
            "kind": "LinkedField",
            "name": "operations",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "operation"
              },
              {
                "kind": "ScalarField",
                "name": "targetType"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ContentPropertiesQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentPropertiesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "78f7f047c2eeaba388f789341164eb05",
    "id": "8e088eb03f247f33e1a36638ceb73aeb312be09e8d8845193a7a0a0b4ff5c388",
    "metadata": {},
    "name": "ContentPropertiesQuery",
    "operationKind": "query",
    "text": "query ContentPropertiesQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,type,properties(key:\"editor\"){nodes{id,key,value}},operations{operation,targetType}}}}"
  }
};
})();

(node as any).hash = "3c9ecddff6610855702eca8455e182f9";

export default node;
